import { coerceCssPixelValue, NumberInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

import { ThemeColorDirective } from '../../directives';

@Component({
    selector: 'lui-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    hostDirectives: [
        { directive: ThemeColorDirective, inputs: ['color', 'secondaryColor'] },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AvatarComponent {
  @Input() get size(): string | null {
    return this._size;
  }
  set size(value: NumberInput) {
    this._size = coerceCssPixelValue(value);
  }
  private _size: string | null = '64px';

  @HostBinding('class') hostClass = 'lui-avatar';

  @HostBinding('style.--size') get sizeCssVariable() {
    return this.size;
  }
}
